module.exports = __webpack_public_path__ + "static/media/female_left_grey.8f28192d.png";